/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Anchor_Clear_BodyInputs */

const en_us2_body_assessment_anchor_clear_body = /** @type {(inputs: Body_Assessment_Anchor_Clear_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later estimates go back to the population range, which is wider. The results already computed do not change.`)
};

const pt_br2_body_assessment_anchor_clear_body = /** @type {(inputs: Body_Assessment_Anchor_Clear_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As próximas estimativas voltam à faixa da população, que é mais larga. Os resultados já calculados não mudam.`)
};

const es_419_body_assessment_anchor_clear_body = /** @type {(inputs: Body_Assessment_Anchor_Clear_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las próximas estimaciones vuelven al rango de la población, que es más amplio. Los resultados ya calculados no cambian.`)
};

const pt_pt2_body_assessment_anchor_clear_body = /** @type {(inputs: Body_Assessment_Anchor_Clear_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As próximas estimativas voltam ao intervalo da população, que é mais largo. Os resultados já calculados não mudam.`)
};

const fr_fr2_body_assessment_anchor_clear_body = /** @type {(inputs: Body_Assessment_Anchor_Clear_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les prochaines estimations reviennent à la fourchette de la population, plus large. Les résultats déjà calculés ne changent pas.`)
};

const de_de2_body_assessment_anchor_clear_body = /** @type {(inputs: Body_Assessment_Anchor_Clear_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spätere Schätzungen nutzen wieder die Spanne der Bevölkerung, die breiter ist. Bereits berechnete Ergebnisse ändern sich nicht.`)
};

const it_it2_body_assessment_anchor_clear_body = /** @type {(inputs: Body_Assessment_Anchor_Clear_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le stime successive tornano all'intervallo della popolazione, che è più ampio. I risultati già calcolati non cambiano.`)
};

/**
* | output |
* | --- |
* | "Later estimates go back to the population range, which is wider. The results already computed do not change." |
*
* @param {Body_Assessment_Anchor_Clear_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_clear_body = /** @type {((inputs?: Body_Assessment_Anchor_Clear_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_Clear_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_clear_body(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_clear_body(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_clear_body(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_clear_body(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_clear_body(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_clear_body(inputs)
	return en_us2_body_assessment_anchor_clear_body(inputs)
});
export { body_assessment_anchor_clear_body as "body-assessment.anchor_clear_body" }